<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
    <div class="loader2"></div>
</div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
            <li><a>Manage</a></li>
            <li><a>Orders</a></li>
          </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home" *ngIf="loginBusinessCategory != 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
          <a routerLink="/home/dashboard" *ngIf="loginBusinessCategory == 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>        </div>
      </div>
      <div class="block">
        <div class="row">
          <div [hidden]="pgLoad">
            <div class="adjust loader-container">
              <div class="loader2"></div>
            </div>
        </div>
        <div class="orders-container" [hidden]="!pgLoad">
          <div class="orders-info-block">
             <div class="row row-block">
               <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                 <div class="col-lg-8 col-md-6 col-sm-6 col-xs-6">
                   <h2 class="orders-text">{{statusText}}<span class="pending-text" *ngIf="statusText == 'New Orders'">pending for approval<span class="pending-orders-count">{{'(' + productOrdersFinalData.length + ')'}}</span></span></h2>
                 </div>
                 <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 filters-block">
                    <div class="filter"(clickOutside)="closeFilterPopup()">
                      <div (click)="openFilterPopUp()">
                        <img src="../../../../../../assets/img/png-icons-blubay/filter icon.svg"><span class="filter-text" >Filters</span>
                      </div>
                      <div class="orders-filter" *ngIf="filtersPopupDisplay">
                        <ul style="list-style: none;">
                          <li [ngClass]="{ 'active-tab': activeFilter == 0}" (click)="getDataOnStatusBasis(0, 'booked')">New order</li>
                          <li [ngClass]="{ 'active-tab': activeFilter == 1}" (click)="getDataOnStatusBasis(1, 'approved')">Approved orders</li>
                          <li [ngClass]="{ 'active-tab': activeFilter == 2}" (click)="getDataOnStatusBasis(2, 'declined')">Decline orders</li>
                        </ul>
                      </div>
                    </div>
                    <div class="days-filter">
                      <select [(ngModel)]="noOfDays" (click)="getDataOnDateBasis(noOfDays)">
                        <option value="All">All</option>
                        <option value="today">Today</option>
                        <option value="lastweek">Last Week</option>
                        <option value="lastmonth">Last Month</option>
                        <option value="lastyear">Last Year</option>
                      </select>
                    </div>
                 </div>
               </div>
             </div>
             <div class="row row-block" *ngIf="productOrdersFinalData && productOrdersFinalData.length > 0 || NoDataMessage">
               <div class="col-lg-12">
                <div class="search">
                  <img src="../../../../../../assets/img/png-icons-blubay/search_icon.svg" width="20" height="20" class="search_icon">
                  <input type="text" class="search_input" (keyup)="searchOrderItems($event)" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by tech, farm" >
                  <img src="../../../../../../assets/img/png-icons-blubay/search_close_icon.svg" width="20" height="20" class="search_close" *ngIf="clearSearchInput" (click)="this.search = '';this.clearSearchInput = false;this.getDataOnDateBasis(noOfDays);NoDataMessage = false">
                </div>
               </div>
             </div>
          </div>
          <div class="orders-block orderCard-scroll-bar" [ngClass]="{'orderCard-scroll-bar': productOrdersFinalData && productOrdersFinalData.length > 7}">
            <div class="row row-flex" *ngIf="productOrdersFinalData && productOrdersFinalData.length > 0">
              <div class="col-lg-6 orders-card" *ngFor="let productOrder of productOrdersFinalData; let i = index;">
                <div class="row orders-info-block">
                  <div class="col-lg-12">
                   <div class="order-details">
                     <div>
                      <span class="order-title">Order ID</span><span class="order-value">{{productOrder && productOrder.order_number}}</span>
                     </div>
                     <div>
                      <span class="order-title">Items</span><span class="order-value">{{productOrder && productOrder.no_of_items_ordered}}</span>
                     </div>
                     <div>
                      <span class="order-title">Fulfilment on</span><span class="order-value">{{(productOrder && productOrder.order_expected_date | date: 'dd MMM yyyy') || '--'}}</span>
                     </div>
                   </div>
                  </div>
                </div>
                <div class="row items-block">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="col-lg-7 col-md-6 col-sm-6 col-xs-6 items-list-block custom-scroll-bar" [ngClass]="{'custom-scroll-bar': productOrder.OrderDetails.length > 2}">
                      <div class="row list-item" *ngFor="let items of productOrder.OrderDetails">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                            <span class="item-list-title">{{items && items.item_name}}</span>
                          </div>
                          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1" style="text-align: right">
                            <span class="item-list-value">{{items && items.ordered_quantity}}</span>
                          </div>
                          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1" style="text-align: right;padding-right: 35px;">
                            <span class="item-list-value">{{items && items.item_uom_name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5 col-md-6 col-sm-6 col-xs-6 comments-block" *ngIf="productOrder.status == 'booked'">
                      <div class="approve-decline" [ngClass]="{'active-approve-decline': activeIndex == i && approveBtnDisplay || activeIndex == i && declineBtnDisplay}">
                        <button class="approve" (click)="changeStatus('approved', i)" *ngIf="!approveBtnDisplay || activeIndex != i">Approve</button>
                        <button class="approved" (click)="changeStatus('approved', i)" *ngIf="approveBtnDisplay && activeIndex == i">Approve</button>
                        <button class="decline" (click)="changeStatus('declined', i)" *ngIf="!declineBtnDisplay || activeIndex != i">Decline</button>
                        <button class="declined" (click)="changeStatus('declined', i)" *ngIf="declineBtnDisplay && activeIndex == i">Decline</button>
                      </div>
                      <div *ngIf="commentsBlockDisplay && i == activeIndex">
                        <textarea id="comment" name="comment" rows="2" cols="25" [(ngModel)]="orderComment" placeholder="Comments"></textarea>
                        <span (click)="acceptDeclineOrders(productOrder, i)">Go</span>
                      </div>
                    </div>
                    <div class="col-lg-5 col-md-6 col-sm-6 col-xs-6" *ngIf="productOrder.status != 'booked'">
                      <div style="padding: 12px">
                        <img src="../../../../../assets/img/png-icons-blubay/approve icon.svg" class="statusImage" *ngIf="productOrder.status == 'approved'">
                        <img src="../../../../../assets/img/png-icons-blubay/decline icon.svg" class="statusImage" *ngIf="productOrder.status == 'declined'">
                        <h5>{{productOrder && productOrder.order_remarks}}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="booked-details">
                      <div>
                        <h4 class="booked-title">Booked date</h4>
                        <h2 class="booked-value">{{productOrder && productOrder.date_ordered | date: 'dd MMM yyyy'}}</h2>
                      </div>
                      <div>
                        <h4 class="booked-title">Booked by</h4>
                        <h2 class="booked-value">{{productOrder && productOrder.generated_by_person_name}}</h2>
                      </div>
                      <div>
                        <h4 class="booked-title">Booked for</h4>
                        <h2 class="booked-value">{{productOrder && productOrder.ordered_to_business_name}}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="productOrdersFinalData && productOrdersFinalData.length == 0 && orderStatus == 'booked' && !NoDataMessage" class="noDataFoundMessage">No Pending Orders</div>
            <div *ngIf="productOrdersFinalData && productOrdersFinalData.length == 0 && NoDataMessage" class="noDataFoundMessage">No Data Available</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
